RivalIQ.apps.AdsInsights.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    data._normalizeParams = function (params) {

        if (!params.childObjectType && !params.breakdownName) {
            // order properties don't make sense without a childObjectType or breakdownName
            params = _.omit(params, ['sortOrder', 'orderBy']);
        }

        const lowSpendFilter = Number(params.lowSpendFilter);
        if (!_.isFinite(lowSpendFilter) || lowSpendFilter === 0) {
            delete params.lowSpendFilter;
        }

        return params;
    };

    const FbAdsInsightsCacheLayer = RivalIQ.data.BatchCacheLayer.extend({

        cacheKeys: [
            'adAccountId',
            'breakdownName',
            'adObjectId',
            'orderBy',
            'sortOrder',
            'childObjectType',
            'limit',
            'campaignObjective',
            'campaignDeliveryStatus',
            'adsetDeliveryStatus',
            'campaignAdLabel',
            'property',
            'lowSpendFilter',
            'filterZeroSpend',
            'boostedPostFilter',
            'channel',
            'timeAnalysisMode',
            'cumulativeDailyValues',
            {
                value: 'dimensions',
                test: function (cacheValue, fetchValue) {

                    cacheValue = cacheValue || [];
                    fetchValue = fetchValue || [];
                    return _.size(cacheValue) === _.size(fetchValue) &&
                        fetchValue.sort().join('-') === cacheValue.sort().join('-');
                }
            },
            RivalIQ.data.CacheLayer.keyType.TIMEPERIOD
        ],

        loadData: function (requests) {
            const me = this;

            const collection = new me.Collection();

            const data = _.map(requests, function (request) {
                const singleRequest = _.extend({}, _.pick(request, me.cacheKeys));
                singleRequest.timePeriod = request.timePeriod;
                singleRequest.dimensions = request.dimensions;
                return singleRequest;
            });

            return collection.fetch({
                data: data
            });
        },

        fetch: function (params) {
            const me = this;

            return me.getOrLoad(data._normalizeParams(params));
        }
    });

    const FbAdObjects = FbAdsInsightsCacheLayer.extend({
        name: 'FbAdObjects',
        Collection: App.collections.FbAdObjectsCollection
    });

    data.fbAdObjects = new FbAdObjects();
});
